export default import.meta.ROLLDOWN_FILE_URL_XGcgQ2mQOkKDcm8NfeR2fw